import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../../Assets/contact_img.png";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import Particle from "../Particle";

function Contact() {
  useScrollReveal();

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null); // null | 'success' | 'error'
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus("error");
      return;
    }
    setSending(true);
    // Replace this with your actual email service (EmailJS, Formspree, etc.)
    await new Promise((r) => setTimeout(r, 1200));
    setSending(false);
    setStatus("success");
    setForm({ name: "", email: "", message: "" });
    setTimeout(() => setStatus(null), 4000);
  };

  return (
    <Container fluid className="contact-section">
      <Particle />
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div className="contact-glass-card reveal">
              {/* Header */}
              <div className="text-center reveal reveal-delay-1" style={{ marginBottom: "2rem" }}>
                <img src={contactImg} alt="Contact" className="contact-image" />
                <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "2em", letterSpacing: "-0.03em" }}>
                  Get In <span className="purple">Touch</span>
                </h1>
                <p style={{ color: "rgba(232,224,240,0.5)", fontSize: "0.95em" }}>
                  Have a project in mind? Let's talk.
                </p>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} noValidate>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your full name"
                  className="contact-field reveal reveal-delay-1"
                  aria-label="Full name"
                  autoComplete="name"
                />
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Your email address"
                  className="contact-field reveal reveal-delay-2"
                  aria-label="Email address"
                  autoComplete="email"
                />
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell me about your project..."
                  rows={5}
                  className="contact-field reveal reveal-delay-3"
                  aria-label="Message"
                  style={{ resize: "vertical" }}
                />

                <button
                  type="submit"
                  className="btn btn-primary w-100 reveal reveal-delay-4"
                  disabled={sending}
                  style={{ marginTop: "0.5rem" }}
                >
                  {sending ? "Sending..." : "Send Message →"}
                </button>
              </form>

              {/* Status feedback */}
              {status === "success" && (
                <div className="contact-status success">
                  ✓ Message sent! I'll get back to you soon.
                </div>
              )}
              {status === "error" && (
                <div className="contact-status error">
                  ✗ Please fill in all fields.
                </div>
              )}

              {/* Direct contact links */}
              <div className="text-center reveal" style={{ marginTop: "2rem", paddingTop: "1.5rem", borderTop: "1px solid var(--color-border)" }}>
                <p style={{ color: "rgba(232,224,240,0.4)", fontSize: "0.85em", marginBottom: "0.5rem" }}>
                  Or reach me directly
                </p>
                <a
                  href="mailto:marwen.meddeb@outlook.fr"
                  style={{ color: "var(--color-primary)", textDecoration: "none", fontSize: "0.95em" }}
                >
                  marwen.meddeb@outlook.fr
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;